import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
import OnlyDateFilter from "./OnlyDateFilter";
import { fetchApiDataDup3 } from "../../../redux/reducers/commonApiSlice";
import { selectToken } from "../../auth/auth.selector";
import { attendanceGet } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  currentMonthCurrentDate,
  currentMonthStartDate,
} from "../../common-data/Converts";

const MemberCheckinLogs = ({
  clickValues,
  // sendableStatsQPs,
  MLCDate,
  MCLDate,
  lastCheckinTRDate,
  from,
}) => {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const { dataDup3, loadingDup3 } = useSelector((state) => state.common);

  // const queryParams = new URLSearchParams(sendableStatsQPs);
  // const startDateParam = queryParams.get("start_date");
  // const endDateParam = queryParams.get("end_date");

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    selectedStartDate: convertStraight(currentMonthStartDate),
    selectedEndDate: convertStraight(currentMonthCurrentDate),
    // selectedStartDate: startDateParam
    //   ? moment(startDateParam).tz("Asia/Kolkata").format("DD-MM-YYYY")
    //   : convertStraight(currentMonthCurrentDate),
    // selectedEndDate: endDateParam
    //   ? moment(endDateParam).tz("Asia/Kolkata").format("DD-MM-YYYY")
    //   : convertStraight(currentMonthCurrentDate),
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const initialFilters = {
    page: isPage + 1,
    limit: pageLimit,
    user_id: clickValues?.userId,
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(initialFilters);
  const iniTbDatas = {
    allData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onClickReset = () => {
    setFilters(initialFilters);
    setAllFilters(iniAllFilters);
  };

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedStartDate: startDateParam
  //       ? moment(startDateParam).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //       : convertStraight(currentMonthCurrentDate),
  //     selectedEndDate: endDateParam
  //       ? moment(endDateParam).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //       : convertStraight(currentMonthCurrentDate),
  //   }));
  // }, [startDateParam, endDateParam]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      user_id: clickValues?.userId,
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [allFilters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (filters.user_id && filters.date_from && filters.date_to) {
      dispatch(
        fetchApiDataDup3({
          method: "GET",
          endpoint: attendanceGet,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (dataDup3?.status && dataDup3?.data?.length > 0) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup3.data || [],
        pagination: dataDup3?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup3]);

  // if (!loadingDup3 && tbDatas.allData?.length === 0) {
  //   return (
  //     <div className="error-container">
  //       <p>No checkin logs found for this member.</p>
  //     </div>
  //   );
  // }

  const tbColumns = [
    {
      dataField: "user_name",
      text: "name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.user_name || "NA"}</span>;
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "date",
      text: "Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {" "}
            {row?.date ? row.date : "-"}
          </span>
        );
      },
    },
    {
      dataField: "time",
      text: "Punch-In History",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.time ? row.time : "-"}</span>;
      },
    },
  ];

  return (
    <>
      <OnlyDateFilter
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        MLCDate={MLCDate}
        MCLDate={MCLDate}
        lastCheckinTRDate={lastCheckinTRDate}
        from={from}
        feature={"last-checkin"}
      />

      {!tbDatas.allData || tbDatas.allData?.length === 0 ? (
        <div className="error-container">
          <p>{dataDup3?.message || "No checkin logs found for this member."}</p>
        </div>
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          {loadingDup3 ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableData={tbDatas.allData}
              tableColumns={tbColumns}
              tablePagination={tbDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </div>
      )}
    </>
  );
};

export default MemberCheckinLogs;
